import React from "react";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Sidebar from "../Parts/Sidebar";
import Header from "../Parts/Header";
import * as Actions from "../../actions/App";
import LoadingGif from "../../assets/images/loading.gif";

class Component extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  _renderLoading = () => {
    const nowLoading = this.props.App.loading;
    // console.log("ローディング判定", nowLoading);
    if (nowLoading) {
      return (
        <div>
          <div className="loading-wrap">
            <img src={LoadingGif} className="loading-icon" alt="loading..." />
          </div>
          <div className="loading-overlay" />
        </div>
      );
    }
    return (
      <div>
        <div className="loading-wrap hidden">
          <img src={LoadingGif} className="loading-icon" alt="loading..." />
        </div>
        <div className="loading-overlay hidden" />
      </div>
    );
  };

  render = () => {
    return (
      <div className="after-signin-wrap">
        <Header />
        <div className="app-container">
          <div className="row">
            <Sidebar />
            <div className="app-body">{this.props.children}</div>
          </div>
        </div>
        {this._renderLoading()}
      </div>
    );
  };
}

const mapStateToProps = state => {
  return state;
};
const mapDispatchToProps = dispatch => bindActionCreators(Actions, dispatch);

const AfterLoginTemplate = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(AfterLoginTemplate)
);
